var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-accordeon.ts
import { isPrinting } from "@adornis/base/client/frontend-helpers";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import { BehaviorController } from "@adornis/chemistry/controllers/behavior-controller";
import { ObservableController } from "@adornis/chemistry/controllers/observable-controller";
import { event } from "@adornis/chemistry/decorators/event";
import { css } from "@adornis/chemistry/directives/css";
import "@adornis/chemistry/elements/components/x-flex";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design";
import "@adornis/chemistry/renderable";
import "@adornis/fonts/fonts";
import { html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import "./ge-toggle-content";
var GermaniumAccordeon = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ":host": {
        "@media print": {
          [`${DesignSystem.prefix}-text`]: { display: "initial !important" }
        }
      }
    });
    this.items = new BehaviorController(this, []);
    this.selected = -1;
    this.isPrinting = new ObservableController(this, isPrinting);
  }
  render() {
    return html`
      <x-flex space="md">
        ${repeat(
      this.items.getValue() || [],
      (item, index) => html`
            <ge-toggle-content
              ${css(
        this.selected === index || this.isPrinting.value ? {
          marginBottom: "0",
          borderStyle: "groove",
          borderColor: this.colors.secondary_500,
          borderRadius: "20px",
          borderWidth: "1px",
          padding: "20px 40px"
        } : {
          borderStyle: "groove",
          borderColor: this.colors.secondary_500,
          borderRadius: "20px",
          borderWidth: "1px",
          padding: "20px 40px"
        }
      )}
              .label=${item.title}
              @open-changed="${(e) => {
        if (e.detail.value !== void 0 && e.detail.value !== null) {
          if (e.detail.value && this.selected !== index)
            this.selected = index;
          else if (!e.detail.value && this.selected === index)
            this.selected = -1;
        }
      }}"
              ?open=${this.selected === index || this.isPrinting.value}
            >
              ${typeof item.text === "string" ? html` <x-text> ${item.text} </x-text> ` : item.text}
            </ge-toggle-content>
            <!-- {this.spacer(index)} -->
          `
    )}
      </x-flex>
    `;
  }
  // protected spacer(index: number) {
  //   return index < this.items.getValue().length - 1
  //     ? html` <div ${css({ height: '1px', width: '100%', background: this.colors.neutral_100 })}></div> `
  //     : nothing;
  // }
};
__decorateClass([
  state()
], GermaniumAccordeon.prototype, "items", 2);
__decorateClass([
  state(),
  event
], GermaniumAccordeon.prototype, "selected", 2);
__decorateClass([
  state()
], GermaniumAccordeon.prototype, "isPrinting", 2);
GermaniumAccordeon = __decorateClass([
  customElement("ge-accordeon")
], GermaniumAccordeon);
export {
  GermaniumAccordeon
};
